import $ from 'jquery';
import { gsap, TimelineMax, Power2, Power4, CSSRulePlugin, ScrollTrigger } from 'gsap/all';
require("../__vendor/SplitText.min.js");
require("../__vendor/jquery.bxslider.js");

const form = () => {
    console.log("FORM");
    $(".form-control input, .form-control textarea").on("focusin", function () {
        $(this).parents(".form-control").addClass("form-control--active");
    });

    $(".form-control input, .form-control textarea").on("focusout", function () {
        //console.log($(this).val().length == 0);
        if($(this).val().length === 0) {
            $(this).parents(".form-control").removeClass("form-control--active");
        }
    });

    $("input[type='file']").on("change", function(e) {
        if($(this).val().length !== 0) {
            $(this).parents(".form-control").addClass("form-control--active");
            $(this).parent().next().text(e.target.files[0].name);
        }
    });
};

export default form;